var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"target":_vm.localTarget,"rel":"noopener","href":_vm.localLink}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.localText))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }